import type {AdSample} from '../types/AdSample';
import type {Sample} from '../types/Sample';
import {isNullish} from '../utils/Utils';

import type {Backend} from './Backend';

/**
 * The `LongPlaytimeFilteringBackend` is a decorator class that filters out samples
 * where the `played` time exceeds a specified threshold.
 *
 * If a sample's `played` time surpasses the threshold, it is not forwarded to the next backend.
 * Otherwise, the sample is passed along to the next backend for further processing.
 *
 * @implements {Backend}
 */
export class LongPlaytimeFilteringBackend implements Backend {
  readonly nextBackend: Backend;

  constructor(next: Backend) {
    this.nextBackend = next;
  }

  sendRequest(sample: Sample): void {
    if (this.isPlayedAboveThreshold(sample)) {
      return;
    }
    this.nextBackend.sendRequest(sample);
  }

  sendUnloadRequest(sample: Sample): void {
    if (this.isPlayedAboveThreshold(sample)) {
      return;
    }
    this.nextBackend.sendUnloadRequest(sample);
  }

  sendAdRequest(adSample: AdSample): void {
    this.nextBackend.sendAdRequest(adSample);
  }

  sendUnloadAdRequest(adSample: AdSample): void {
    this.nextBackend.sendUnloadAdRequest(adSample);
  }

  private isPlayedAboveThreshold(sample: Sample): boolean {
    return (isNullish(sample.played) ? 0 : sample.played) >= 90000;
  }
}
